/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ProjectSubmissionMode {
    SUBMIT_FOR_ESTIMATION = 'SUBMIT_FOR_ESTIMATION',
    SUBMIT_FOR_TRANSLATION = 'SUBMIT_FOR_TRANSLATION',
    BOTH = 'BOTH',
    SUBMIT_FOR_ESTIMATION_EXCEPT = 'SUBMIT_FOR_ESTIMATION_EXCEPT',
    SUBMIT_FOR_TRANSLATION_EXCEPT = 'SUBMIT_FOR_TRANSLATION_EXCEPT',
}
